import { render, staticRenderFns } from "./IndustryCostData.vue?vue&type=template&id=b4aeaa9e&scoped=true&"
import script from "./IndustryCostData.vue?vue&type=script&lang=js&"
export * from "./IndustryCostData.vue?vue&type=script&lang=js&"
import style0 from "./IndustryCostData.vue?vue&type=style&index=0&id=b4aeaa9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4aeaa9e",
  null
  
)

export default component.exports